<script setup lang="ts">
import { faCartShopping } from '@fortawesome/pro-light-svg-icons'
import { useCart } from '@consumer/services/order'
import HeaderButton from '../HeaderButton.vue'

const cart = useCart()
</script>

<template>
  <HeaderButton :icon="faCartShopping" aria-label="Cart">
    <span
      v-if="cart.count > 0"
      class="
      absolute -top-1.5 -right-1.5
      text-xs font-semibold bg-v2-active text-white
      rounded-full h-5 w-5 flex items-center justify-center"
    >
      {{ cart.count }}
    </span>
  </HeaderButton>
</template>
